import ModelContextProtocolSVG from '@frontend/assets/ModelContextProtocol.svg';
import OptimizelyIconSVG from '@frontend/assets/o-logo.svg';

type IconName = 'optimizely' | 'mcp';

const CustomIconMap: Record<IconName, string> = {
  optimizely: OptimizelyIconSVG,
  mcp: ModelContextProtocolSVG,
};

export function CustomIcon({
  name = 'optimizely',
  ...props
}: {
  name: IconName;
} & React.ImgHTMLAttributes<HTMLImageElement>) {
  if (!(name in CustomIconMap)) {
    return null;
  }
  return <img src={CustomIconMap[name]} alt={props.alt || name} {...props} />;
}
